import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const selectableCardVariants = cva(
  "group relative flex rounded-card border transition-colors outline-none focus-visible:ring-[2px] focus-visible:ring-ring/20 disabled:pointer-events-none disabled:opacity-60 [&_svg]:shrink-0",
  {
    variants: {
      layout: {
        stacked: "flex-col items-center justify-center text-center",
        row: "w-full flex-col text-left",
      },
      size: {
        default: "gap-3 p-5",
        compact: "gap-1.5 p-3",
      },
      isSelected: {
        true: "border-action bg-action-tint",
        false: "border-border bg-card hover:border-action/50 hover:bg-muted/30",
      },
    },
    defaultVariants: {
      layout: "stacked",
      size: "default",
      isSelected: false,
    },
  },
);

function SelectableCard({
  className,
  layout,
  size,
  isSelected = false,
  type = "button",
  ...props
}: Omit<React.ComponentProps<"button">, "type"> &
  Omit<VariantProps<typeof selectableCardVariants>, "isSelected"> & {
    isSelected?: boolean;
    type?: "button" | "submit";
  }) {
  return (
    <button
      type={type}
      data-slot="selectable-card"
      data-selected={isSelected || undefined}
      className={cn(
        selectableCardVariants({ layout, size, isSelected, className }),
      )}
      {...props}
    />
  );
}

export { SelectableCard, selectableCardVariants };
